import { render, staticRenderFns } from "./DanhGiaList.vue?vue&type=template&id=563df4ee&scoped=true"
import script from "./DanhGiaList.vue?vue&type=script&lang=js"
export * from "./DanhGiaList.vue?vue&type=script&lang=js"
import style0 from "./DanhGiaList.vue?vue&type=style&index=0&id=563df4ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563df4ee",
  null
  
)

export default component.exports